import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './MyAdsSection.styles';
import { Ads } from '@/components/Profile/Ads/Ads';
import { Ad } from '@/api/types/common.types';

type Props = {
  adsLatest?: Ad[];
};

export const MyAdsSection = ({ adsLatest }: Props) => {
  const { t } = useTranslation();
  return (
    <S.ContentCard>
      <S.Title $variant="2">{t('pages.cabinet.my_ads')}</S.Title>
      <Ads adsLatest={adsLatest} />
    </S.ContentCard>
  );
};
